<app-top-bar-wrapper [type]="DashboardType.MY_COMPETITION" [attr.data-testid]="DataTestIds.TOP_BAR_WRAPPER">
  <div dashboard class="main-container">
    <app-top-level-metrics [attr.data-testid]="DataTestIds.TOP_LEVEL_METRICS"></app-top-level-metrics>
    <app-overview-tiles [type]="'competition'" [loading]="loadingState.overview" [overview]="overview" [myBrand]="getBrandsKeys().brandKey"
      [brandColors]="brandColorsMap()" [attr.data-testid]="DataTestIds.OVERVIEW" [showAskPolaris]="true"></app-overview-tiles>
    <div *ngIf="creativeGalleryData.total || creativeGalleryVolumeThreshold" class="widgets-wrapper" [attr.data-testid]="DataTestIds.CREATIVE_GALLERY">
      <div class="widget-container gallery">
        <app-widget-container [title]="'Creative Gallery'" [control]="gallerySort" [selectMode]="SelectMode.SINGLE" [selectWidth]="'248px'"
        [tooltip]="tooltips.creativeGallery" [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.CREATIVE_GALLERY_COMPETITION"
                              [selectOptions]="gallerySortOptions" [searchable]="false" [placeholder]="'Select sort field'" [selectAllAndClearOptions]="false"
                              [showVolumeFilter]="true" (volumeFilterApplied)="onCreativeGalleryVolumeFilter($event)"
                              (apply)="onSortFieldChange()" [compareWith]="compareOptions" [selectDisabled]="!creativeGalleryData.total">
          <app-creative-gallery *ngIf="creativeGalleryData.total" [data]="creativeGalleryData.creativesData" [loading]="loadingState.creativeGallery" [brandskeys]="getBrandsKeys().competitorsKeys"
            [getterName]="'getCompetitorCreativeCard'" (requestPageChange)="onCreativeModalEdgeNav($event)">
          </app-creative-gallery>
          <app-no-widget-data *ngIf="!creativeGalleryData.total && !loadingState.creativeGallery"></app-no-widget-data>
        </app-widget-container>
        <div class="paginator-container">
          <app-paginator *ngIf="creativeGalleryData.total" #creativeGalleryPaginator
                         [length]="creativeGalleryData.total" [pageSize]="CREATIVE_GALLERY_LIMIT" [initialPage]="initialPage"
                         (page)="onCreativeGalleryPageChange($event)">
          </app-paginator>
        </div>
      </div>
    </div>
    <div class="widgets-wrapper" [attr.data-testid]="DataTestIds.SPEND_EFFICIENCY">
      <div class="widget-container spend-efficiency">
        <app-widget-container [title]="'Spend Analysis'" [tooltip]="tooltips.spendEfficiency"
                              [control]="spendEfficiencyXAxisControl" [selectMode]="SelectMode.SINGLE"
                              [selectOptions]="spendEfficiencyXAxisOptions" [searchable]="false"
                              [secondControl]="spendEfficiencyYAxisControl" [secondSelectOptions]="spendEfficiencyYAxisOptions"
                              [selectWidth]="'180px'" [secondSelectWidth]="'180px'"
                              [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.SPEND_ANALYSIS"
                              (apply)="onSpendEfficiencyMetricChange()"  [selectedMetrics]="spendEfficiencySelectedMetrics">
          <app-brand-logo-graph [data]="spendEfficiencyData" [yMetric]="spendEfficiencyYAxisControl.value"
                                [xMetric]="spendEfficiencyXAxisControl.value" [loading]="loadingState.spendEfficiency"></app-brand-logo-graph>
        </app-widget-container>
      </div>
    </div>
    <div class="widgets-wrapper">
      <div class="widget-container share-of-voice" [attr.data-testid]="DataTestIds.SHARE_OF_VOICE">
        <app-widget-container
          [title]="SHARE_OF_VOICE_WIDGET_TITLE"
          [tooltip]="tooltips.shareOfVoice"
          [selectMode] = "SelectMode.MULTI"
          [control]="shareOfVoiceCategoryControl"
          [selectOptions]="shareOfVoiceCategoriesOptions"
          [selectWidth]="'160px'"
          [selectDropdownWideWidth]="true"
          [searchable]="true"
          [placeholder]="'All Categories'"
          [showPlaceholderAllSelected]="true"
          [selectAllAndClearOptions]="true"
          (apply)="onShareOfVoiceCategoryChange()"
          [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.SHARE_OF_VOICE"
          >
          <app-pie-chart [loading]="loadingState.shareOfVoice" [data]="shareOfVoiceData" [colors]="sortedShareOfVoiceColors" [isCompactMode]="true"
            [chartWidth]="388" format="percentage" valueField="share"></app-pie-chart>
        </app-widget-container>
      </div>
      <div class="widget-container performance-over-time">
        <app-widget-container
          [title]="'Performance Over Time'" [tooltip]="tooltips.performanceOverTime" [control]="performanceMetricControl"
          [selectMode]="SelectMode.SINGLE" [selectOptions]="performanceMetricOptions" [searchable]="false" [selectWidth]="'248px'"
          [disabledByLength]="true" (apply)="onPerformanceMetricChange()" [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.PERFORMANCE_OVER_TIME"
          [attr.data-testid]="DataTestIds.PERFORMANCE_OVER_TIME">
          <app-performance-over-time
            [data]="performanceData" [loading]="loadingState.performanceOverTime"
            [metric]="performanceMetricControl.value"
            [brandColors]="brandColorsMap()" [brandLineColorsMap]="brandLineColorsMap()"
            valueField="share" [format]="performanceOverTimeFormat"
            [isUnderDateThreshold]="performanceDataIsUnderDateThreshold">
          </app-performance-over-time>
        </app-widget-container>
      </div>
    </div>
    <div class="widgets-wrapper" [attr.data-testid]="DataTestIds.PERFORMANCE_MAP">
      <app-widget-container class="widget-container performance-map"
        [title]="'Performance Map'" [control]="performanceMapMetricControl" [selectMode]="SelectMode.SINGLE" [selectWidth]="'248px'"
        [selectOptions]="performanceMapMetricOptions" [searchable]="false" [placeholder]="'Select metric'" [selectDisabled]="!performanceMapData.myBrand?.length"
        [tooltip]="tooltips.performanceMap" [showVolumeFilter]="true" (volumeFilterApplied)="onPerformanceMapVolumeFilter($event)"
        (apply)="onPerformanceMapMetricChange()" [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.PERFORMANCE_MAP">
        <app-competition-performance-map [loading]="loadingState.performanceMap" [data]="performanceMapData" [type]="performanceMapType"
          [metric]="performanceMapSelectedOption" [brandColors]="brandColorsByNameMap()">
        </app-competition-performance-map>
        <ng-container *ngIf="performanceMapData.myBrand?.length">
          <div class="divider"></div>
          <app-tabs (emitter)="switchPerformanceMapTab($event)" [tabs]="['Worldwide', 'US']"
            [styleClass]="'performance-map'">
          </app-tabs>
        </ng-container>
      </app-widget-container>
    </div>
    <div class="widgets-wrapper">
      <div  class="widget-container content-category" [style.--content-category-height]="contentCategoryHeight" [attr.data-testid]="DataTestIds.CONTENT_CATEGORY_DISTRIBUTION">
        <app-widget-container [title]="'Audience Interests'"
                              [alignCenter]="false" [tooltip]="tooltips.buyingByStrategy" [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.AUDIENCE_INTERESTS">
          <app-content-category-distribution
            [data]="contentCategoryDistributionData"
            [loading]="loadingState.contentCategoryDistribution"
            [myBrand]="myBrand()"
            [myCompetitors]="myCompetitors()"
            [brandColorsMap]="this.brandColorsMap()"
            (collapseExpand)="onContentCategoryListToggle($event)"
          >
          </app-content-category-distribution>
        </app-widget-container>
      </div>
    </div>
    <div class="widgets-wrapper" [attr.data-testid]="DataTestIds.AUDIENCE_GENDER">
      <div class="widget-container audience-gender">
        <app-widget-container
          [title]="'Audience Reach by Gender'"
          [tooltip]="tooltips.audienceGender"
          [askPolarisWidget] = "WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.AUDIENCE_REACH_BY_GENDER">
          <app-audience-gender-chart
            [data]="audienceGenderData"
            [loading]="loadingState.audienceGender">
          </app-audience-gender-chart>
        </app-widget-container>
      </div>
    </div>
    <div class="widgets-wrapper">
      <div class="widget-container performance-by-device" [attr.data-testid]="DataTestIds.PERFORMANCE_BY_DEVICE">
        <app-widget-container
          [title]="'Performance by Device'"
          [tooltip]="tooltips.performanceByDevice"
          [control]="performanceByDeviceMetricControl"
          [selectMode]="SelectMode.SINGLE"
          [selectOptions]="performanceByDeviceOptions"
          [searchable]="false"
          [selectWidth]="'248px'"
          [selectDisabled]="!performanceByDeviceData?.brands?.length"
          (apply)="onPerformanceByDeviceMetricChange()"
          [askPolarisWidget]="WIDGET_QUESTIONS_MAPPING_FOR_DOMAIN.PERFORMANCE_BY_DEVICE">
          <app-performance-by-device
            [data]="performanceByDeviceData"
            [loading]="loadingState.performanceByDevice"
            [metric]="performanceByDeviceSelectedMetric"
            [brandColors]="brandColorsMap()">
          </app-performance-by-device>
        </app-widget-container>
      </div>
    </div>
    <div class="widgets-wrapper">
      <div class="widget-container performance-comparison" [attr.data-testid]="DataTestIds.PERFORMANCE_COMPARISON">
        <app-widget-container [title]="'Performance Comparison'" [tooltip]="tooltips.performanceComparison" [control]="comparisonMetricControl"
                              [selectMode]="SelectMode.SINGLE" [selectOptions]="comparisonMetricOptions" [searchable]="false" [selectWidth]="'248px'"
                              (apply)="onComparisonMetricChange()" [selectDisabled]="comparisonData.length === 0">
          <app-horizontal-bar-chart [data]="comparisonData" [loading]="loadingState.comparison" [colors]="sortedComparisonColors" [format]="comparisonFormat" [noDataView]="'svg/no-widget-data.svg'"
                                    valueField="score" [comparison]="myBrandCompareValue"></app-horizontal-bar-chart>
        </app-widget-container>
      </div>
      <div class="widget-container performance-by-time" [attr.data-testid]="DataTestIds.PERFORMANCE_BY_TIME">
        <app-widget-container
          [title]="'Hourly Breakdown'"
          [tooltip]="tooltips.performanceByTime"
          [control]="performanceByTimeMetricControl"
          [selectMode]="SelectMode.SINGLE"
          [selectOptions]="performanceByTimeOptions"
          [searchable]="false"
          [selectWidth]="'248px'"
          [selectDisabled]="!performanceByTimeData?.brands?.length"
          [showVolumeFilter]="true" (volumeFilterApplied)="onPerformanceByTimeVolumeFilter($event)"
          (apply)="onPerformanceByTimeMetricChange()">
          <app-performance-by-time
            [data]="performanceByTimeData"
            [loading]="loadingState.performanceByTime"
            [metric]="performanceByTimeSelectedMetric"
            [brandColors]="brandColorsMap()"
            >
          </app-performance-by-time>
        </app-widget-container>
      </div>
    </div>
    <div class="table-container" [attr.data-testid]="DataTestIds.INVENTORY_QUALITY">
      <div class="table-header-container">
        <div class="table-header">Competitors' Inventory Quality</div>
        <ng-content *ngIf="competitorsInventoryQualityData?.total">
        </ng-content>
      </div>
      <ng-content *ngIf="competitorsInventoryQualityData?.total || loadingState.inventoryQuality; else noInventoryData">
        <div class="table-content">
          <app-sites-table [tableData]="competitorsInventoryQualityData?.sites ?? []" [loading]="loadingState.inventoryQuality"
            (sortChange)="this.onSortInventoryQualityTable($event)" [columnPrefix]="'Competitor'"></app-sites-table>
          <app-paginator #inventoryQualityPaginator [length]="competitorsInventoryQualityData?.total || 0"
            [pageSize]="inventoryQualityPageSize" [initialPage]="initialPage"
            (page)="onInventoryQualityPageChange($event)" [rowControl]="true" [rowsTitle]="rowsPerPage"
            (rowsChange)="onInventoryQualityRowsChange($event)">
          </app-paginator>
        </div>
        </ng-content>
      <ng-template #noInventoryData>
        <app-no-widget-data class="wide-container"></app-no-widget-data>
      </ng-template>
    </div>
  </div>
</app-top-bar-wrapper>
